import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["img", "title"]

  connect() {
    console.log("✅ image-modal CONNECTED", this.element)
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget
    const imageUrl = button.dataset.imageModalUrlValue
    const modalId = button.dataset.imageModalTargetId
    const title = button.dataset.imageModalTitleValue || ""

    if (!imageUrl || !modalId) return

    const modalEl = document.getElementById(modalId)
    if (!modalEl) return console.warn("Modal not found:", modalId)

    const controller = this
    const img = modalEl.querySelector("[data-image-modal-target='img']")
    const titleEl = modalEl.querySelector("[data-image-modal-target='title']")
    img.src = imageUrl
    if (titleEl) titleEl.textContent = title

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl)
    modal.show()
  }
}
